import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { showFlameIcon, getUrgencyMessage } from 'site-modules/shared/utils/inventory-utils/get-urgency-message';

export function ContactDealerTip({
  daysToSell = null,
  classNamesWrapper = 'text-center mb-0',
  classNamesMsg = 'mb-1 mt-2 mt-md-2 mb-md-0',
  hideNoFireTip = false,
  defaultMsg = '',
  styleWrapper = {},
}) {
  const hasFlameIcon = showFlameIcon(daysToSell);
  const message = getUrgencyMessage(daysToSell, defaultMsg);

  if (!hasFlameIcon && hideNoFireTip) {
    return null;
  }

  return (
    message && (
      <div className={classNames('size-16 fw-normal', classNamesWrapper)} style={styleWrapper}>
        <div className={classNamesMsg}>
          {hasFlameIcon && <i className="icon-fire me-0_25 text-warning" aria-hidden />}
          {message}
        </div>
      </div>
    )
  );
}

ContactDealerTip.propTypes = {
  daysToSell: PropTypes.number,
  classNamesWrapper: PropTypes.string,
  classNamesMsg: PropTypes.string,
  hideNoFireTip: PropTypes.bool,
  defaultMsg: PropTypes.string,
  styleWrapper: PropTypes.shape({}),
};
